<!-- xnotif modal template -->
@if (parentView.xnotifVisible) {
<tray [style.z-index]="12"
      open="100"
      [narrow]="true"
      [priority]="30"
      [fullOpen]="30"
      (offClick)="parentView.closeXnotifTray()">

    <!-- back button -->
    <button class="pos-absolute top-0 left-0 m-t-3-s m-l-4-s z-5 cursor-pointer"
            aria-label="Close email notifications tray"
            (click)="parentView.closeXnotifTray()">
        <i class="icon-arrow-left fs-6"
           aria-hidden="true"></i>
    </button>

    <exponea-stock-notification class="block p-t-10 p-b-10"
                                [model]="product"
                                (openSizeTray)="parentView.closeXnotifTray()"
                                (closeSizeTray)="parentView.closeXnotifTray()" />
</tray>
}